import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { getSubmissionList, publishWinnerList } from "../../../features/slices/challanges";
import { useSelector } from "react-redux";
import CommonPagination from "../../CommonPagination";
import { toastService } from "../../../utils/toastify";
import moment from "moment";

const LiveSubmissionCompleted = () => {
  const { type } = useParams();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [page, setPage] = useState(1);
   const navigate = useNavigate();

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  console.log(type, "typee")

  useEffect(() => {
    if (state) {
      dispatch(getSubmissionList({ challengeId: state, page }));
    }
  }, [page, state, dispatch]);
  const { submissionList } = useSelector((state) => {
    return state?.challenges;
  });
  const handlePublish = () => {
    dispatch(publishWinnerList({ challengeId: state })).then((data) => {
      if (data?.payload?.code == 200) {
        toastService.success("WinnerList publish successfully");
        navigate("/challenges");
      } else {
        toastService.error("WinnerList publish failed");
      }
    });
  };
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TableList">
            <table className="table-hover">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Student Id</th>
                  <th>Student Name</th>
                  <th>Submitted On</th>
                  <th>View Submission</th>
                  {type != "ongoing" && <th>Ranks &amp; Points</th>}
                </tr>
              </thead>
              <tbody>
                {submissionList?.result?.[0]?.paginationData?.map((res, i) => {
                  return (
                    <tr key={res?._id}>
                      <td>{(page - 1) * 10 + i + 1}</td>
                      <td>{res?.studentData?.user_number}</td>
                      <td>{res?.studentData?.fullName}</td>
                      <td>
                        {moment(res?.submitAt).format("DD/MM/YYYY") ||
                          "25 / 10 / 2023"}
                      </td>
                      {/* <td>25/10/2023</td> */}
                      <td>
                        <div className="Actions justify-content-start">
                          <Link
                            to={"/challenges/submissionDetail"}
                            className="Eyes"
                            state={res}
                          >
                            <i className="fa-regular fa-eye" />
                          </Link>
                        </div>
                      </td>
                      {type != "ongoing" && <td>
                        {res?.studentRank ? (
                          <>
                            {`${res?.studentRank} Rank ${res?.studentPoints} Points `}
                            <Link
                              to="/challenges/rankPointAdd"
                              className="Black"
                              state={{ ...res, update: true }}
                              style={{
                                minWidth: "auto",
                              }}
                            >
                              <i className="fa-regular fa-pen-to-square" />
                            </Link>
                          </>
                        ) : (
                          <Link
                            to="/challenges/rankPointAdd"
                            className="Black"
                            state={res}
                          >
                            Add Rank &amp; Points
                          </Link>
                        )}
                      </td>}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="Pagination">
            <p>
              Showing {(page - 1) * 10 + 1} to{" "}
              {submissionList?.result?.[0]?.paginationData?.length +
                (page - 1) * 10}{" "}
              of {submissionList?.result?.[0]?.totalCount?.[0]?.count} results
            </p>
            <div className="PaginationRight">
              {submissionList?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <CommonPagination
                  activePage={page}
                  itemsCountPerPage={10}
                  totalItemsCount={
                    submissionList?.result?.[0]?.totalCount?.[0]?.count || 0
                  }
                  pageRangeDisplayed={4}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              )}
            </div>
          </div>
        </div>
       {type != "ongoing" && <button className="Button" onClick={handlePublish}>
          Publish
        </button>}
      </div>
    </div>
  );
};

export default LiveSubmissionCompleted;
